import React from "react";

const DietPlanPackageBooking = React.lazy(() => import("./index"));
const CreatePackageBooking = React.lazy(() =>
  import("../BookingFeatures/CreatePackageBooking")
);
const CreatePackageInvoiceBooking = React.lazy(() =>
  import("../BookingFeatures/CreatePackageInvoiceBooking")
);
const DietPackageBookingDetail = React.lazy(() => import("./Details"));
const CreateInvoiceReceipt = React.lazy(() =>
  import("../BookingFeatures/CreateInvoiceReceipt")
);
const InvoiceTemplate = React.lazy(() =>
  import("../BookingFeatures/Template/InvoiceTemplate")
);
const InvoiceReceipt = React.lazy(() =>
  import("../BookingFeatures/Template/InvoiceReceipt")
);
const InvoiceReceiptDetail = React.lazy(() =>
  import("components/BookingFeatures/BookingDetails/InvoiceReceiptDetail")
);
const CreateNutritionPlan = React.lazy(() =>
  import("component/NutritionPlan/CreateNutritionPlan")
);

export const DietPlanPackageBookingRoute = [
  {
    path: "/admin/nutritionPlanPackageBookings",
    name: "DietPlanPackageBooking",
    element: <DietPlanPackageBooking />,
  },
  {
    path: "/admin/nutritionPlanPackageBookings/create",
    name: "CreatePackageBooking",
    element: <CreatePackageBooking />,
  },
  {
    path: "/admin/nutritionPlanPackageBookings/create/:memberId",
    name: "CreatePackageBooking",
    element: <CreatePackageBooking />,
  },
  {
    path: "/admin/nutritionPlanPackageBookings/:packageId",
    name: "DietPackageBookingDetail",
    element: <DietPackageBookingDetail />,
  },
  {
    path: "/admin/nutritionPlanPackageBookings/createInvoice/:packageId",
    name: "CreatePackageInvoiceBooking",
    element: <CreatePackageInvoiceBooking />,
  },
  {
    path: "/admin/nutritionPlanPackageBookings/createInvoiceReceipt/:packageId",
    name: "CreateInvoiceReceipt",
    element: <CreateInvoiceReceipt />,
  },
  {
    path: "/admin/nutritionPlanPackageBookings/invoice/:invoiceId",
    name: "InvoiceReceipt",
    element: <InvoiceTemplate />,
  },
  {
    path: "/admin/nutritionPlanPackageBookings/invoiceReceipt/:invoiceId",
    name: "InvoiceReceipt",
    element: <InvoiceReceipt />,
  },
  {
    path: "/admin/nutritionPlanPackageBookings/:packageId/invoiceReceipt/:receiptId",
    name: "InvoiceReceiptDetail",
    element: <InvoiceReceiptDetail />,
  },
  {
    path: "/admin/nutritionPlanPackageBookings/:packageId/addNutrition",
    name: "CreateNutritionPlan",
    element: <CreateNutritionPlan />,
  },
  {
    path: "/admin/nutritionPlanPackageBookings/:packageId/updateNutrition/:nutritionId",
    name: "CreateNutritionPlan",
    element: <CreateNutritionPlan />,
  },
];
